import { UNDERLINE_COLOR } from '@app/core/cms-flex/types';

import { UnderlineType } from '../types';

export const UNDERLINE_TYPE = new Map<UNDERLINE_COLOR, UnderlineType>()
  .set(UNDERLINE_COLOR.BLACK, 'head-underline__black')
  .set(UNDERLINE_COLOR.TURQUOISE, 'head-underline__turquoise')
  .set(UNDERLINE_COLOR.ORANGE, 'head-underline__orange');
